import { render, staticRenderFns } from "./MinaSidorLayout.vue?vue&type=template&id=79c5925b"
import script from "./MinaSidorLayout.vue?vue&type=script&lang=js"
export * from "./MinaSidorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports